import { render, staticRenderFns } from "./consultantteam.vue?vue&type=template&id=7da1ad63&"
import script from "./consultantteam.vue?vue&type=script&lang=js&"
export * from "./consultantteam.vue?vue&type=script&lang=js&"
import style0 from "./consultantteam.vue?vue&type=style&index=0&id=7da1ad63&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports